import { observable, action, runInAction } from 'mobx';
import { cloneDeep, isEmpty } from 'lodash';

import Service from '@service/index';

const moCustomer = observable({
  allList: <any[]>[],
  list: <any[]>[],
});

const getList = action(async () => {
  const res: any = await Service.comments();
  runInAction(() => {
    if (!isEmpty(res)) {
      moCustomer.allList = cloneDeep(res.slice(0, 9));
      moCustomer.list = cloneDeep(res.slice(0, 6));
    }
  });
});

// value为true, 取9条数据
// value为false, 取6条数据
const changeList = action((value: boolean) => {
  let arr: any[] = [];
  if (value) arr = cloneDeep(moCustomer.allList);
  else arr = cloneDeep(moCustomer.allList.slice(0, 6));
  moCustomer.list = arr;
});

export default moCustomer;
export { getList, changeList };
